import React from "react";

import classnames from "classnames";

import { Div } from "Common/HTML";
import { useThemeContext } from "Theme/Context";

import makeBem from "Utils/makeBem";

const UnthemedDottedBox = ({ children, themeClass, className, disabled, ...rest }) => (
  <Div
    className={classnames(bem(), themeClass, className, {
      [bem(null, "disabled")]: disabled,
    })}
    {...rest}
  >
    {children}
  </Div>
);

const bem = makeBem("DottedBox");
/**
 * Visually works as a 'glorified button'.
 * On hover the cursor changes to a pointer.
 * Not mandatory to have a click handler, but there probably should be one..
 */
const DottedBox = ({ children, cobaltProps = {}, classicProps = {}, intuitProps = {}, ...rest }) => {
  const { intuit, cobalt } = useThemeContext();
  return intuit ? (
    <UnthemedDottedBox {...rest} themeClass={bem(null, "intuit")} {...intuitProps}>
      {children}
    </UnthemedDottedBox>
  ) : cobalt ? (
    <UnthemedDottedBox {...rest} themeClass={bem(null, "cobalt")} {...cobaltProps}>
      {children}
    </UnthemedDottedBox>
  ) : (
    <UnthemedDottedBox {...rest} themeClass={bem(null, "classic")} {...classicProps}>
      {children}
    </UnthemedDottedBox>
  );
};

export default DottedBox;
